var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 36,
    height: 23,
    rx: 2,
    fill: "#E3E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.2A2 2 0 0 1 12.3 0h11.4a2 2 0 0 1 1.8 1.2L29 9H7l3.5-7.8Z",
    fill: "#E3E9EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 5,
    fill: "#E3E9EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 8.5,
    r: 1.5,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoPhoto);
export default ForwardRef;